import { useEffect, useState } from "react";
import api, { formatMoney } from "@/lib/api";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

export default function Reports() {
  const [companies, setCompanies] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/super-admin/companies");
        setCompanies(data);
      } catch {}
    })();
  }, []);

  const totalEmp = companies.reduce((a, c) => a + (c.employee_count || 0), 0);
  const totalInv = companies.reduce((a, c) => a + (c.invoice_count || 0), 0);
  const totalUsers = companies.reduce((a, c) => a + (c.user_count || 0), 0);

  return (
    <div className="space-y-6" data-testid="sa-reports-page">
      <div>
        <div className="font-mono text-[10px] tracking-widest uppercase text-zinc-500 mb-2">Insights</div>
        <h1 className="font-heading text-4xl font-black tracking-tight">Reports</h1>
        <p className="text-sm text-zinc-500 mt-1">Per-company breakdown across the entire platform.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Tile label="Total companies" value={companies.length} />
        <Tile label="Total users (all roles)" value={totalUsers} />
        <Tile label="Total employees" value={totalEmp} />
      </div>

      <div className="bg-white border border-zinc-200 rounded-sm">
        <div className="px-6 py-4 border-b border-zinc-200">
          <div className="font-mono text-[10px] tracking-widest uppercase text-zinc-500">Per-company</div>
          <h3 className="font-heading text-lg font-bold tracking-tight">Breakdown</h3>
        </div>
        <Table>
          <TableHeader>
            <TableRow className="bg-zinc-50 hover:bg-zinc-50">
              <TableHead className="font-mono text-[10px] uppercase tracking-widest text-zinc-500">Company</TableHead>
              <TableHead className="font-mono text-[10px] uppercase tracking-widest text-zinc-500">Plan</TableHead>
              <TableHead className="font-mono text-[10px] uppercase tracking-widest text-zinc-500">Status</TableHead>
              <TableHead className="font-mono text-[10px] uppercase tracking-widest text-zinc-500 text-right">Users</TableHead>
              <TableHead className="font-mono text-[10px] uppercase tracking-widest text-zinc-500 text-right">Employees</TableHead>
              <TableHead className="font-mono text-[10px] uppercase tracking-widest text-zinc-500 text-right">Invoices</TableHead>
              <TableHead className="font-mono text-[10px] uppercase tracking-widest text-zinc-500">Created</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {companies.length === 0 && (
              <TableRow><TableCell colSpan={7} className="text-center py-16 text-sm text-zinc-500">No data yet.</TableCell></TableRow>
            )}
            {companies.map((c) => (
              <TableRow key={c.id} className="hover:bg-zinc-50">
                <TableCell>
                  <div className="font-medium text-sm">{c.name}</div>
                  <div className="font-mono text-[10px] uppercase tracking-widest text-zinc-500">{c.slug}</div>
                </TableCell>
                <TableCell><span className="font-mono text-[10px] uppercase tracking-widest">{c.plan}</span></TableCell>
                <TableCell><span className="font-mono text-[10px] uppercase tracking-widest">{c.status}</span></TableCell>
                <TableCell className="text-right font-mono text-sm">{c.user_count}</TableCell>
                <TableCell className="text-right font-mono text-sm">{c.employee_count}</TableCell>
                <TableCell className="text-right font-mono text-sm">{c.invoice_count}</TableCell>
                <TableCell className="font-mono text-xs">{c.created_at?.slice(0, 10)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}

function Tile({ label, value }) {
  return (
    <div className="bg-white border border-zinc-200 p-6 rounded-sm">
      <div className="font-mono text-[10px] tracking-widest uppercase text-zinc-500 mb-2">{label}</div>
      <div className="font-heading text-3xl font-black tracking-tight">{value}</div>
    </div>
  );
}
